import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';
import { RuntimeState } from "@/store/flux360/PrefabDataTypes";

class Audio extends BasicComponent {
    getType() { return "Audio"; }

    constructor( { id } = {} ) {
        super( { id });
        this.prefab = undefined,
        this.context = undefined,
        this.audio = undefined,
        this.volume = undefined
    }

    construct( context, prefab ) {

        this.context = context;
        const base = super.construct( context, prefab ).getRootNode();

        console.log("Getting Audio for " + prefab.getAudioID() );
        var audioFile = MediaManager.getMedia(prefab.getAudioID());
        console.log("audioFile.fileName: " + audioFile.fileName + "url: " + audioFile.getURL());
        
        var name = "Audio_"+audioFile.getID();

        var myVolume = parseFloat(prefab.getVolumeScale()) / 100;
        
       // var myAudio = new BABYLON.Sound(name, audioFile.getURL(), window.scene, prefab.getAutoplay()? function() {if(myAudio.isInCurrentRoom)
            // Sound has been downloaded & decoded
          //  myAudio.play();} :null, {
         var myAudio = new BABYLON.Sound(name, audioFile.getURL(), window.scene, prefab.getAutoplay()? function() {myAudio.play();} :null, {
       
            loop: prefab.getLooping(),
            autoplay: false,
            volume: myVolume,
            skipCodecCheck: true 
          });
          myAudio.play_on_entering = true; //prefab.getAutoplay();
   
         this.audio = myAudio;
         this.prefab = prefab;
         myAudio.parent = base;
        return base;
    }

   
    
    getLength(){
        return this.audio.getAudioBuffer().duration;
    }
    
    
    pause(){
        console.log("Audio - pause");
        super.pause();      
        this.audio.pause();
        this.prefab.runtimeState.pauseType=RuntimeState.PauseType.Explicit;
    }
    play(){
        console.log("Audio - play");
        super.play();
        if(!this.audio.isPlaying){
            this.audio.play();
        }
        this.prefab.runtimeState.duration = this.audio.getAudioBuffer().duration;
        this.prefab.runtimeState.pauseType=RuntimeState.PauseType.Implicit;
    }

    reset(){
        super.reset();
        console.log("Audio - reset");
       //this.audio.updateOptions({offset:0.0});
    }

    mute(){
        super.mute();
        console.log("Audio -Mute");
        
        this.volume = this.audio.getVolume();
        console.log("Volume was: " + this.volume);
        this.audio.setVolume(0);
    }

    unmute(){
        super.unmute();
        console.log("Audio - UnMute");
        if(this.volume){
            this.audio.setVolume(this.volume);
        }
        else
           this.audio.setVolume(1);
    }

    jumpToTimePosition(timeToJumpTo){
        super.jumpToTimePosition(timeToJumpTo); 
        this.audio.getAudioBuffer().currentTime = timeToJumpTo;
    }

    disable(){
        super.disable();
        this.audio.pause();
    }

    enable(){      
        super.enable();
        console.log("Audio - Enable"); 
        if(this.prefab && this.prefab.runtimeState && this.prefab.runtimeState.pauseType!=RuntimeState.PauseType.Explicit){
            this.audio.play();
        }
        //if(this.audio.play_on_entering === true){
        //    this.audio.play();
        //}
    }


    update () {
        if( (this.audio.isPaused() != this.prefab.runtimeState.paused) || 
            (this.audio.getVolume()===0 != this.prefab.runtimeState.muted) ||
            (this.audio.isPlaying() != this.prefab.runtimeStae.playing) ||
            (this.audio.getAudioBuffer().duration != this.prefab.runtimeStae.duration) ){
            this.window.scene.$store.commit('updateRuntimeState',{id:this.prefab.getID(), paused:this.audio.isPaused(), 
                playing:this.prefab.runtimeStae.playing, muted:(this.audio.getVolume()===0), duration:this.audio.getAudioBuffer().duration});      
        }
    }
}

export default Audio;
